module.exports = __webpack_public_path__ + "static/Cotton_NORMAL_MAP-9ce9364835106d1d40d26757c5e3eab5.jpg";